// src/assets/images/index.js
import simakeupa from './simakeup-1.jpeg';
import simakeupb from './simakeup-2.jpeg';
import simakeupc from './simakeup-3.jpeg';
import bisindoappa from './bisindoappa.png';
import bisindoappb from './bisindoappb.png';
import bisindoappc from './bisindoappc.jpg';
import ratingpagea from './ratingpagea.png';
import ratingpageb from './ratingpageb.png';
import ratingpagec from './ratingpagec.png';
import salerokitoa from './salerokitoc.png';
import salerokitob from './salerokitob.png';
import salerokitoc from './salerokitoa.png';
import diskominfoa from './diskominfoa.png';
import diskominfob from './diskominfob.png';
import diskominfoc from './diskominfoc.png';
import dalangana from './dalangana.png';
import dalanganb from './dalanganb.png';
import dalanganc from './dalanganc.png';
import esca from './esca.png';
import escb from './escb.png';
import escc from './escc.png';

import eyecarea from './eyecare.png';
import eyecareb from './eyecareb.png';
import eyecarec from './eyecarec.png';
import vectora from './vectora.png';
import vectorb from './vectorb.jpg';
import trida from './3da.jpg';
import tridb from './3db.jpg';
import tridc from './3dc.jpeg';



export const simakeupA = simakeupa;
export const simakeupB = simakeupb;
export const simakeupC = simakeupc;
export const bisindoA = bisindoappa;
export const bisindoB = bisindoappb;
export const bisindoC = bisindoappc;
export const ratingpageA = ratingpagea;
export const ratingpageB = ratingpageb;
export const ratingpageC = ratingpagec;
export const salerokitoA = salerokitoa;
export const salerokitoB = salerokitob;
export const salerokitoC = salerokitoc;
export const diskominfoA = diskominfoa;
export const diskominfoB = diskominfob;
export const diskominfoC = diskominfoc;
export const dalanganA = dalangana;
export const dalanganB = dalanganb;
export const dalanganC = dalanganc;
export const escA = esca;
export const escB = escb;
export const escC = escc;


export const eyecareA = eyecarea;
export const eyecareB = eyecareb;
export const eyecareC = eyecarec;
export const vectorA = vectora;
export const vectorB = vectorb;
export const tridA = trida;
export const tridB = tridb;
export const tridC = tridc;




